import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { PageState } from 'app/store/models/page.model';
import { getIsAuthenticated } from 'app/store/selectors/user.selector';

@Injectable()
export class NonAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<PageState>
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.select(getIsAuthenticated).pipe(
      take(1),
      map((result: boolean) => {
        if (result) {
          localStorage.setItem('comming_from', 'login');
          this.router.navigate(['/messages']);
        }

        return !result;
      })
    );
  }
}
